import { Browser, OpenOptions } from "@capacitor/browser";
import i18n from "@/core/i18n";

const addLangToUrl = (url: string) => {
  if (url.includes("?")) {
    return url + "&lang=" + i18n.global.locale;
  } else {
    return url + "?lang=" + i18n.global.locale;
  }
};

export const useBrowse = () => (options: OpenOptions) =>
  Browser.open({
    windowName: "_self",
    ...options,
    url: addLangToUrl(options.url),
  });
